
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CaseStudy from "../pages/case-study/page";
import HOACaseStudy from "../pages/hoa-case-study/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/case-study/sureworx",
    element: <CaseStudy />,
  },
  {
    path: "/case-study/hoa-application",
    element: <HOACaseStudy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
